import { render } from "./Sort.vue?vue&type=template&id=506bd858&scoped=true"
import script from "./Sort.vue?vue&type=script&lang=js"
export * from "./Sort.vue?vue&type=script&lang=js"

import "./Sort.vue?vue&type=style&index=0&id=506bd858&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506bd858"]])

export default __exports__